import React from "react";
import { useLocation } from "react-router-dom";
import { useGlobalStateContext } from "../../context/globalContext";
import { cookies } from "../../store/actions";
import CQYLogo from "../../assets/CQY_9.15_IT_RGB.png";
import CQYLogoWhite from "../../assets/CQY_WHITE.png";
import CQYLogoParitaGenere from "../../assets/parita-colore.png";
import CQYLogoParitaGenereWhite from "../../assets/parita-bianco.png";
import OdooGoldDarkLogo from "./OdooGoldDarkLogo";
import OdooGoldLightLogo from "./OdooGoldLightLogo";
import InstagramLogo from "../../assets/instagram.svg";
import LinkedinLogo from "../../assets/linkedin.svg";
import FacebookLogo from "../../assets/facebook-icon.svg";
import InstagramColored from "../../assets/instagram-colored.svg";
import LinkedinColored from "../../assets/linkedin-icon.svg";
import FacebookColored from "../../assets/facebook-colored.svg";
import pdfCertiqality from "../../assets/unitiva_certiquality.pdf";
import pdfParitaGenere from "../../assets/iso-125-2022.pdf";
import pdfCertiqualityIso from "../../assets/iso_27001.pdf";
import genderEqualityWhite from "../../assets/parita-generelogo-bianco.png";
import genderEqualityDark from "../../assets/parita-generelogo-nero.png";
import footerSeparator from "../../assets/footer_separator.png";
import openApiLogo from "../../assets/openapi-partner-gold.png";
import pdfCertiqualityWhite from "../../assets/CQY_27.22_RGB-iso2022_WHITE.png";
import pdfCertiqualityDark from "../../assets/CQY_9.15_IT_RGB_DARK.png";
import * as S from "./style";

interface FooterProps {
  popupVisibility: boolean | undefined;
  setPopupVisibility: (arg: boolean) => void;
  darkBackground?: boolean;
}

const firstEntry = [
  "© 2021 - UNITIVA S.R.L.",
  "REA NA - 938997 - capitale sociale 50.000 i.v. | P.IVA: 08172641212",
  "Via Medina, 40 , cap 80133 Napoli",
  "Via Piave, 36, cap 00187 Roma",
  "Viale Abruzzi, 94, cap 20131 Milano",
  'La società UNITIVA S.R.L. ha implementato e gestisce un "Sistema di gestione',
  'sulla parità di genere, diversità ed inclusione", ai sensi della UNI/PdR 125:2022',
];

const listItems = [
  { name: "Privacy", url: "/privacy" },
  { name: "Cookie Policy", url: "/cookie" },
  { name: "Contacts", url: "/contact" },
  { name: "Sustainability", url: "/sustainability" },
  { name: "Certificazioni", url: "/certificazioni" },
];

const contactListItems = [
  { content: "info@unitiva.it", href: "mailto:info@unitiva.it" },
  { content: "tel. +39 081 65 81 180", href: "tel:+390816581180" },
];

const Footer: React.FC<FooterProps> = ({ setPopupVisibility }) => {
  const token =
    typeof window !== "undefined" ? cookies.get("auth_token") : null;
  const { pathname } = useLocation();
  const { context } = useGlobalStateContext();

  const onButtonClick = () => {
    if (token) {
      cookies.set("auth_token", "", { path: "/" });
      window.location.reload(true);
    } else {
      setPopupVisibility(true);
    }
  };

  if (pathname === "/") {
    return null;
  }

  return (
    <S.Footer dark={!context.isCaseStudy}>
      <ul>
        <li>
          <div className="listData">
            {firstEntry.map((item, i) => (
              <div key={i}>{item}</div>
            ))}
          </div>
        </li>

        <li className="footer__contacts">
          <div className="listData">
            {listItems.map((item, i) => (
              <a key={i} href={item.url}>
                {item.name}
              </a>
            ))}
          </div>
        </li>

        <li>
          <div className="listData">
            {contactListItems.map((item, i) => (
              <a key={i} href={item.href}>
                {item.content}
              </a>
            ))}
            <div className="footer__socials">
              <FacebookIcon />
              <LinkedInIcon />
              <InstagramIcon />
            </div>
          </div>
        </li>
      </ul>

      <div className="footer-separator">
        <img src={footerSeparator} alt="Linea separatrice" />
      </div>

      <ul>
        <li>
          <a
            className="footer__odooLogoGold"
            href="https://www.odoo.com/it_IT/partners/unitiva-srl-5470915?country_id=106"
            target="_blank"
          >
            {context.isCaseStudy ? <OdooGoldDarkLogo /> : <OdooGoldLightLogo />}
          </a>
        </li>

        {/* <li>
          {context.isCaseStudy ? (
            <img
              className="genderEqualityCertification"
              src={genderEqualityDark}
              alt="Gender Equality Certification"
            />
          ) : (
            <img
              className="genderEqualityCertification"
              src={genderEqualityWhite}
              alt="Gender Equality Certification"
            />
          )}
        </li> */}

        <li>
          <a href="https://openapi.it/partner/unitiva-srl" target="_blank">
            <img
              className="openApiLogo"
              src={openApiLogo}
              alt="Open Api Logo"
            />
          </a>
        </li>

        <li>
          {context.isCaseStudy ? (
            <a href={pdfCertiqualityIso} target="_blank">
              <img
                className="pdfCertiquality"
                src={pdfCertiqualityDark}
                alt="CQY Logo Dark"
              />
            </a>
          ) : (
            <a href={pdfCertiqualityIso} target="_blank">
              <img
                className="pdfCertiquality"
                src={pdfCertiqualityWhite}
                alt="CQY Logo White"
              />
            </a>
          )}
        </li>

        <li>
          <a
            className="footer__certiqalityLogoGold"
            href={pdfCertiqality}
            target="_blank"
          >
            <img
              alt="CQY Logo"
              src={context.isCaseStudy ? CQYLogo : CQYLogoWhite}
            />
          </a>
        </li>

        <li>
          <a
            className="footer__certiqalityLogoGold"
            href={pdfParitaGenere}
            target="_blank"
          >
            <img
              alt="CQY Logo Parita Genere"
              src={
                context.isCaseStudy
                  ? CQYLogoParitaGenere
                  : CQYLogoParitaGenereWhite
              }
            />
          </a>
        </li>
      </ul>
    </S.Footer>
  );
};

const FacebookIcon: React.FC<{}> = () => {
  const { context } = useGlobalStateContext();
  return (
    <i className="icon facebookIcon">
      <a href="https://www.facebook.com/unitiva.it/">
        <img
          src={context.isCaseStudy ? FacebookColored : FacebookLogo}
          alt="Facebook"
        />
      </a>
    </i>
  );
};

const LinkedInIcon: React.FC<{}> = () => {
  const { context } = useGlobalStateContext();
  return (
    <i className="icon linkedInIcon">
      <a href="https://it.linkedin.com/company/unitivasrls">
        <img
          src={context.isCaseStudy ? LinkedinColored : LinkedinLogo}
          alt="Linkedin"
        />
      </a>
    </i>
  );
};

const InstagramIcon: React.FC<{}> = () => {
  const { context } = useGlobalStateContext();

  return (
    <i className="icon instagramIcon">
      <a href="https://www.instagram.com/unitiva.it/">
        <img
          src={context.isCaseStudy ? InstagramColored : InstagramLogo}
          alt="Instagram"
        />
      </a>
    </i>
  );
};

export default Footer;
